export enum ReadabilityMode {
  Default = 'default',
  Large = 'large',
}
